/**
 * Loads types. Operational load data comes from QuickManage + spreadsheets,
 * merged server-side in the `loads` edge function (see docs/ARCHITECTURE.md).
 * `public.loads` is an overlay/cache when APIs are read-only or for imports.
 */

export type LoadStatus =
  | "booked"
  | "dispatched"
  | "in_transit"
  | "out_for_delivery"
  | "delivered"
  | "exception";

export type LoadSource = "quickmanage" | "spreadsheet" | "manual";

export interface LoadRecord {
  id: string;
  reference: string;
  origin: string;
  destination: string;
  status: LoadStatus;
  pickup: string;
  delivery: string;
  carrierName: string;
  driverName: string;
  equipmentId: string;
  equipmentUnit: string;
  driverProfileId: string | null;
  carrierProfileId: string | null;
  customerRef: string;
  source: LoadSource;
  quickmanageId: string;
  internalNotes: string;
  equipmentWarnings: LoadEquipmentWarning[];
  updatedAt: string;
}

export interface LoadEquipmentWarning {
  severity: "warning" | "danger";
  message: string;
  quickmanageUnit: string;
  fleetioUnit: string;
  quickmanageStatus: string;
  fleetioStatus: string;
}

export interface LoadListMeta {
  quickmanage: boolean;
  spreadsheets: boolean;
  overlay: boolean;
}

export const DRIVER_STATUS_OPTIONS: LoadStatus[] = [
  "dispatched",
  "in_transit",
  "out_for_delivery",
  "delivered",
];
